import React, { Component } from 'react'

function fmt(n, digits) {
  if (n == null || !Number.isFinite(Number(n))) return '—'
  return Number(n).toFixed(digits)
}

const btn = (on) => ({
  border: '1px solid rgba(255,255,255,0.28)',
  borderRadius: 12,
  padding: '6px 10px',
  background: on ? 'rgba(40, 90, 70, 0.88)' : 'rgba(20, 20, 20, 0.72)',
  color: '#fff',
  fontSize: 12,
  cursor: 'pointer',
  width: '100%',
  textAlign: 'left',
})

/**
 * Panel Capas y ROI (Modo B + cuantificación). Fuera de la barra de chips.
 */
export default class Mpr3dLayersPanel extends Component {
  render() {
    const q = this.props.quant
    const hasMask = !!this.props.hasMask
    const err = this.props.error
    return (
      <div
        data-mpr3d-ui="1"
        style={{
          position: 'absolute',
          top: 8,
          right: 8,
          width: 236,
          maxHeight: 'calc(100% - 96px)',
          overflow: 'auto',
          zIndex: 8,
          background: 'rgba(8, 12, 18, 0.88)',
          border: '1px solid rgba(255,255,255,0.16)',
          borderRadius: 12,
          padding: 10,
          color: '#e8f0ff',
          fontSize: 12,
          pointerEvents: 'auto',
        }}
      >
        <div style={{ fontSize: 10, letterSpacing: 0.7, textTransform: 'uppercase', color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>
          Capas y ROI
        </div>
        <button type="button" style={btn(this.props.baseVisible)} onPointerDown={this.props.onToggleBase}>
          {this.props.baseVisible ? '●' : '○'} Volumen base
        </button>
        <div style={{ height: 6 }} />
        <button
          type="button"
          style={btn(this.props.maskOn)}
          onPointerDown={this.props.onToggleMask}
          disabled={!hasMask}
          title={hasMask ? 'Modo B: oculta el CT fuera de la máscara' : 'Cargá un DICOM-SEG o máscara del servidor'}
        >
          {this.props.maskOn ? '●' : '○'} Máscara (Modo B)
        </button>
        <div style={{ height: 6 }} />
        <button
          type="button"
          style={btn(false)}
          onPointerDown={this.props.onIsolate}
          disabled={!hasMask}
          title="Oculta el volumen base y encuadra el bounding box de la lesión"
        >
          Aislar lesión
        </button>
        <div style={{ height: 8 }} />
        {this.props.onLoadSegFile ? (
          <label style={{ ...btn(false), display: 'block', boxSizing: 'border-box' }}>
            Cargar DICOM-SEG
            <input
              type="file"
              accept=".dcm,.dicom,application/dicom,.json"
              style={{ display: 'none' }}
              onChange={(ev) => {
                const f = ev.target.files && ev.target.files[0]
                if (f) this.props.onLoadSegFile(f)
                ev.target.value = ''
              }}
            />
          </label>
        ) : null}
        {this.props.segUrl ? (
          <div style={{ marginTop: 6, fontSize: 10, color: 'rgba(200,220,255,0.65)', wordBreak: 'break-all' }}>
            SEG: {this.props.segUrl}
          </div>
        ) : null}
        {err ? (
          <div style={{ marginTop: 8, color: '#ffb4b4', fontSize: 11 }}>{err}</div>
        ) : null}
        <div
          style={{
            marginTop: 10,
            padding: 8,
            borderRadius: 8,
            background: 'rgba(20, 40, 55, 0.7)',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          <div style={{ fontSize: 10, letterSpacing: 0.6, textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)', marginBottom: 6 }}>
            Cuantificación
          </div>
          {!q || !q.count ? (
            <div style={{ color: 'rgba(255,255,255,0.45)' }}>Sin ROI cargada</div>
          ) : (
            <div>
              <div>Volumen <b>{fmt(q.volumeCm3, 2)}</b> cm³</div>
              <div>Vóxeles {q.count}</div>
              <div>HU min/max {fmt(q.huMin, 0)} / {fmt(q.huMax, 0)}</div>
              <div>HU μ {fmt(q.huMean, 1)} · σ {fmt(q.huStd, 1)}</div>
            </div>
          )}
        </div>
      </div>
    )
  }
}
